<template>
  <loading v-if="loading"></loading>
  <div class="homework" v-else>
    <!-- 头部 -->
    <div class="homework-big">
      <div class="homework-top">
        <div class="homework-top-title">{{ workName || "我的作业" }}</div>
        <div class="homework-top-title">
          <el-button
            type="primary"
            @click="getSubmit"
            :loading="btnloading"
            :disabled="!form.content && !form.file && form.images.length == 0"
          >
            提交作业
          </el-button>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="homework-content">
      <div
        class="homework-content_box"
        style="overflow: auto; position: relative"
      >
        <div class="homework-content_title">作业描述：</div>
        <div class="homework-content_textarea">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容，尽情发挥吧。"
            v-model="form.content"
            style="width:600px"
          >
          </el-input>
        </div>
        <div class="homework-content_imgList">
          <UploadList
            v-model="form.images"
            :width="'120px'"
            :height="'120px'"
          ></UploadList>
        </div>
        <div class="homework-content_accessory">
          <span>附件:</span>
          <div
            class="homework-content_accessoryBox"
            v-if="form.file && form.file.name"
          >
            <img src="@/assets/image/zip.png" alt="" style="width: 50px" />
            {{ form.file.name }}
            <img
              src="@/assets/image/accdel.png"
              alt=""
              style="width: 35px; cursor: pointer"
              @click="del"
            />
          </div>
          <UploadOneFile
            v-else
            :file_url="file.file"
            :text="'上传作业'"
            :width="'267px'"
            @update="update"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import UploadOneFile from "@/components/UploadOneFile/UploadOneFile.vue";
import loading from "@/components/loading/loading.vue";
import UploadList from "@/components/UploadList/index.vue";
export default {
  components: { UploadOneFile, loading, UploadList },
  data() {
    return {
      loading: false,
      input: "",
      list: [],
      details: null,
      file: {
        id: "",
        file: "",
      },
      form: {
        id: "",
        content: "",
        images: [],
        file: "",
      },
      btnloading: false,
      loadingWork: true,
      active: 0,
      workName: "",
    };
  },
  created() {
    this.form.id = this.$route.query.id;
    // this.getList();
    this.getDetails();
  },
  methods: {
    getUrlBase64(url) {
      return new Promise((resolve) => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let img = new Image();
        img.crossOrigin = "Anonymous"; //允许跨域
        img.src = url;
        img.onload = function () {
          canvas.height = 300;
          canvas.width = 300;
          ctx.drawImage(img, 0, 0, 300, 300);
          let dataURL = canvas.toDataURL("image/png");
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    judgeType(name) {
      let result = "";
      let suffix = "";
      try {
        var flieArr = name.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      let imglist = ["png", "jpg", "jpeg", "bmp", "gif"];
      result = imglist.some(function (item) {
        return item == suffix;
      });
      return result;
    },
    download(item) {
      console.log(item);
      let res = this.judgeType(item.url);
      if (res) {
        this.getUrlBase64(item.url).then((base64) => {
          let link = document.createElement("a");
          link.href = base64;
          link.download = item.name;
          link.click();
        });
      } else {
        let routeUrl = item.url.replace(/http:/, "https:");
        window.open(routeUrl + "?attname=" + item.name, "_parent");
      }
    },
    load() {
      if (!this.noMore) {
        this.form.limit += 10;
        this.getList();
      }
    },
    del(index) {
      this.form.file = "";
      this.$forceUpdate(); //强制更新
    },
    update(e) {
      console.log(e);
      this.form.file = e;
      console.log(this.form.file);
      this.$forceUpdate(); //强制更新
    },
    // 提交作业
    getSubmit() {
      if (!this.form.content) {
        this.$message.error("作业描述不能为空！")
        return
      }
      this.btnloading = true;
      request({
        url: "/api/userend/user/homeworkSubmit",
        method: "post",
        params: {
          id: this.form.id,
          content: this.form.content || "",
          images: this.form.images || "",
          file: this.form.file || "",
        },
      }).then((response) => {
        this.btnloading = false;
        this.getDetails();
        this.$message.success("提交成功");
      });
    },
    // 作业详情
    getDetails(index) {
      // this.active = index;
      // this.loadingWork = true;
      request({
        url: "/api/userend/user/homeworkDetail",
        method: "get",
        params: { id: this.form.id },
      }).then((response) => {
        this.workName = response.data?.schedule_homework.title;
        this.form.content = response.data.schedule_student_homework[0]?.content;
        this.form.file = JSON.parse(
          response.data.schedule_student_homework[0]?.file
        );
        this.form.images =
          response.data.schedule_student_homework[0]?.images || [];
        // this.details = response.data;
        // this.file.id = response.data.id;
        // this.loadingWork = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  .el-dialog__headerbtn {
    font-size: 1.5rem;
  }
  .el-dialog__title {
    color: #1e2134;
    font-weight: 500;
    font-size: 22px;
  }
}
/deep/ .el-dialog {
  border-radius: 1rem;
}
.homework {
  .homework-big {
    position: fixed;
    top: 80px;
    width: 100%;
    margin: 0 auto;
    height: 100px;
    background: #f9fafd;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    .homework-top {
      position: fixed;
      top: 100px;
      right: 18px;
      width: 70%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      border-radius: 8px;
      padding: 20px 30px;
      .homework-top-title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #506176;
      }
      .homework-top-search {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .el-input {
          margin-right: 15px;
        }
        .el-select {
          margin-right: 15px;
        }
      }
    }
  }
  .nodata {
    // height: calc(100vh - 600px);
    margin-top: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 407px;
      height: 355px;
    }
    span {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
  }
  .left-box_active {
    border-bottom: 2px solid #3d7eff !important;
  }
  .homework-content {
    margin-top: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    // flex-direction: row;
    // justify-content: flex-end;
    width: 100%;
    &_box {
      border-radius: 8px 8px 0px 0px;
      width: 100%;
      // margin-left: 33px;
      padding: 30px;
      background: #fff;
    }
    &_title {
      font-size: 22px;
      color: #333333;
      line-height: 30px;
    }
    &_textarea {
      margin-top: 20px;
    }
    &_imgList {
      margin-top: 28px;
    }
    &_accessory {
      display: flex;
      align-items: center;
      margin-top: 50px;
      span {
        font-size: 22px;
        margin-right: 10px;
      }
    }
    &_accessoryBox {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      font-size: 18px;
      height: 80px;
      min-width: 285px;
      background: #f9fafd;
    }
  }
}
.homework-accessory {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .homework-accessory_left {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .homework-accessory_right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 105px;
    height: 38px;
    background: #3d7eff;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
}
.dialog-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .dialog-box_left {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    line-height: 25px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
  .dialog-box_right {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 88px;
    height: 36px;
    background: #3d7eff;
    border-radius: 6px;
    color: #fff;
  }
}
.homework_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 108px;
  height: 42px;
  background: #f24342;
  border-radius: 6px;
  color: #fff;
  margin-top: 30px;
}
</style>